export const formatStringToValidI18nKey = (unformatedValue: string) =>
  unformatedValue
    .toLocaleLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w|\s+|\.+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase(),
    )
    .replace(/\s+|\.+/g, "");
